import axios from "axios";
 
const PDFResource = {
  /**
   * Converts base64 string to Blob
   * @param {string} base64Data - Base64 encoded string (with or without data URI prefix)
   * @param {string} contentType - MIME type (default: 'application/pdf')
   * @returns {Blob} - Blob object
   */
  base64ToBlob: (base64Data, contentType = 'application/pdf') => {
    try {
 
      // Remove data URI prefix if present (e.g., "data:application/pdf;base64,")
      let base64String = base64Data;
      if (base64Data.includes(',')) {
        base64String = base64Data.split(',')[1];
      }
 
      // Decode base64 string to binary
      const byteCharacters = atob(base64String);
 
      // Create byte array
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
 
      const byteArray = new Uint8Array(byteNumbers);
 
      // Create Blob
      const blob = new Blob([byteArray], { type: contentType });
 
      return blob;
    } catch (error) {
      console.error("=== base64ToBlob ERROR ===");
      console.error("Error:", error);
      throw new Error(`Failed to convert base64 to Blob: ${error.message}`);
    }
  },

  
  isDataURI: (url) => {
    if (!url) {
      return false;
    }
    
    // Convert to string and trim
    const urlString = String(url).trim();
    
    // Remove quotes if present
    const cleanUrl = urlString.replace(/^["']|["']$/g, '');
    
    const result = cleanUrl.startsWith('data:');
    
    return result;
  },

  normalizeURL:(url) =>{
    if(!url) return null ;
    let cleanUrl = String(url).trim().replace(/^["']|["']$/g,'');
    if(cleanUrl.startsWith('data:') || cleanUrl.startsWith('blob:')||cleanUrl.startsWith('https://') || cleanUrl.startsWith('http://')) {
      return cleanUrl
    }


    if(cleanUrl.startsWith('https:/') && !cleanUrl.startsWith('https://')){
      let pathPart = cleanUrl.substring(7);
      const correctedUrl = `${window.location.origin}/${pathPart}`
      return correctedUrl
    }


    if(cleanUrl.startsWith('http:/') && !cleanUrl.startsWith('http://')){
      let pathPart = cleanUrl.substring(6);
      const correctedUrl = `${window.location.origin}/${pathPart}`
      return correctedUrl
    }

    if(cleanUrl.match(/^https?\/[^\/]/)){
      let pathPart ;
      if(cleanUrl.startsWith('https:/')){
        pathPart = cleanUrl.substring(7)
      }else {
        pathPart = cleanUrl.substring(6)
      }

      if(pathPart.startsWith('/')){
        pathPart = pathPart.substring(1);
      }

      const correctedUrL = `${window.location.origin}/${pathPart}`
      return correctedUrL
    }

    if((cleanUrl.startsWith('http://') || cleanUrl.startsWith('https://')) && !cleanUrl.startsWith('http:/') && !cleanUrl.startsWith('https://')){
      let pathPart;
      if(pathPart.startsWith('https://')){
        pathPart = pathPart.substring(8);
      }else {
        pathPart = pathPart.substring(7);
      }
      const correctedUrl = `${window.location.origin}/${pathPart}`
      return correctedUrl;
    }
       if ((cleanUrl.startsWith('http:') && !cleanUrl.startsWith('http:/')) || (cleanUrl.startsWith('https:') && !cleanUrl.startsWith('https:/'))){
        let pathPart;
        if(cleanUrl.startsWith('https:')){
          pathPart = cleanUrl.substring(6);
        }else {
          pathPart = cleanUrl.substring(5);
        }
        const correctedUrl = `${window.location.origin}/${pathPart}`
        return correctedUrl
       }
    
     if(cleanUrl.startsWith('https://https') || cleanUrl.startsWith('https://http/') || cleanUrl.startsWith('http://http/') || cleanUrl.startsWith('http://https')){

      let pathPart = cleanUrl;
      const correctedUrl = `${window.location.origin}/${pathPart}`;
      return correctedUrl
     }


     if(cleanUrl.startsWith("https://") || cleanUrl.startsWith('http://')){
      const urlObj = cleanUrl.startsWith('https://')?cleanUrl.substring(8):cleanUrl.substring(7)
      const domainPart = urlObj.split('/')[0];
      const invaildDomains = ['static','media' ,'public','assets','api','https','http'];
      if(!domainPart.includes('.') || invaildDomains.includes(domainPart.toLocaleLowerCase()) ){
        const correctedURL = `${window.location.origin}/${urlObj}`;
        return correctedURL;
      }
      return cleanUrl
     }
     
     if(cleanUrl.startsWith('//')){
      const protocol = window.location.protocol;
      const correctedUrl = `${protocol}${cleanUrl}`
      return correctedUrl
     }

     if(cleanUrl.startsWith('/')){
      return `${window.location.origin}${cleanUrl}`
     }
     return `${window.location.origin}/${cleanUrl}`;
  },


  
  detectURLType:(url) =>{
    if(!url) return 'invaild';
    const urlString = String(url).trim();
    
    const cleanUrl = urlString.replace(/^["']|["']$/g,'');
    if(cleanUrl.startsWith('data:')) return 'dataURI';
    if(cleanUrl.startsWith('blob:')) return 'blobURL' ;
    if(cleanUrl.startsWith('http://') || cleanUrl.startsWith('https://')) return 'http' 
    if(cleanUrl.includes('/') || cleanUrl.includes('.')){
      return 'http'
    }
    return 'unknown';
  },
  
 
  /**
   * Check if URL is a data URI (bulletproof version)
   * @param {string} url - URL to check
   * @returns {boolean} - True if data URI
   */
 
  /**
   * Converts data URI to Blob URL
   * @param {string} dataURI - Data URI string
   * @returns {string} - Blob URL
   */
  dataURIToBlobURL: (dataURI) => {
    try {
      
      // Extract MIME type
      const mimeMatch = dataURI.match(/data:([^;]+);/);
      const mimeType = mimeMatch ? mimeMatch[1] : 'application/pdf';
      
      // Convert to Blob
      const blob = PDFResource.base64ToBlob(dataURI, mimeType);
      
      // Create Blob URL
      const blobUrl = window.URL.createObjectURL(blob);
      
      return blobUrl;
    } catch (error) {
      console.error("=== dataURIToBlobURL ERROR ===");
      console.error(error);
      throw error;
    }
  },
 
  /**
   * Downloads PDF and returns as Blob (handles HTTP URLs, data URIs, and Blob URLs)
   * @param {string} url - The PDF URL, data URI, or Blob URL
   * @returns {Promise<{data: Blob}>} - Response with blob data
   */
  downloadPDFAsBlob: async (url) => {
    try {

      const normalizedUrl = PDFResource.normalizeURL(url);
      
      if(!normalizedUrl){
        throw new Error("Invalid or empty URL provided");
      }
       
      const urlType = PDFResource.detectURLType(normalizedUrl);

      switch(urlType){
        case 'dataURI': {
          const mimeMatch = normalizedUrl.match(/data:([^;]+);/);
          const mimeType = mimeMatch ? mimeMatch[1] : 'application/pdf';

          const blob = PDFResource.base64ToBlob(normalizedUrl,mimeType);
          return {
            data : blob,
            status:200,
            statusText:'OK',
            headers:{'content-type':mimeType},
            config:{url:normalizedUrl}
          }
        }
        case 'blobURL' : {
          const response = await fetch(normalizedUrl);
          if(!response.ok){
            throw new Error(`blob fetch failed: ${response.status} ${response.statusText}`);
    
          }
          const blob = await response.blob();
          return {
            data: blob,
            status: response.status,
            statusText:response.statusText,
            headers:{'content-type': blob.type},
            config: {url:normalizedUrl}
          };
        }
        case 'http':{
          try {
            const response = await axios({
              method:'get',
              url:normalizedUrl,
              responseType:'blob',
              headers:{
                'Accept': 'applicaiton/pdf',
              }, 
              timeout:30000,
              onDownloadProgress:(progressEvent)=>{
                if(progressEvent.total){
                  const percentCompleted= Math.round((progressEvent.loaded*100)/progressEvent.total);
                }
              }
            });
            let blobData = response.data;
            if(!(blobData instanceof Blob)){
              blobData = new Blob([response.data],{type:'applicaiton/pdf'});
            }
            if(blobData.size === 0){
              throw new Error("Received empty PDF blob");
            }
            return {
              ...response, 
              data: blobData
            };
          }catch(axiosError){
            console.warn("Axios failed ,, tyring fetching Api..");
            const resposne  = await fetch(normalizedUrl);
            if(!resposne.ok){
              throw new Error(`HTTP ${resposne.status}: ${resposne.statusText}`)
            }
            const blob = await resposne.blob();
            return{
              data:blob,
              status: resposne.status,
              statusText:resposne.statusText,
              headers:{ 'content-type': blob.type},
              config:{url:normalizedUrl}
            };
          }
        }
        default:{
          try{
            const response = await fetch(normalizedUrl);
            if(!response.ok){
              throw new Error (`Fetch failed: ${response.status} ${response.statusText}`)
            }
            const blob = await response.blob();
            return {
              data : blob, 
              status: response.status,
              statusText : response.statusText,
              headers:{
                'content-type':blob.type
              },
              config:{
                url: normalizedUrl
              }
            };
          }catch(fetchError){
            throw new Error(
              `could not download pdf from url: ${normalizedUrl.substring(0,50)}...\n` +
              `Original error : ${fetchError.message , fetchError}`
            );
          }
        }
      }
    } catch (error) {
      console.error("=== PDFResource.downloadPDFAsBlob ERROR ===");
      console.error("Error name:", error.name);
      console.error("Error message:", error.message);
      
      // Provide helpful error messages
      if (error.message === "Network Error") {
        console.error("💡 Network Error - This usually means:");
        console.error("   1. CSP blocking the request");
        console.error("   2. CORS issue");
        console.error("   3. Data URI being passed to axios");
        console.error("   Solution: Use Blob URL instead of data URI");
      }
      
      console.error("Full error:", error);
      throw error;
    }
  },
 
  /**
   * Helper function to detect iOS devices
   * @returns {boolean} - True if iOS device
   */
  isIOS: () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    // Check for iPad, iPhone, iPod
    const isIOSDevice = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    
    // Check for iPad on iOS 13+ (reports as MacIntel)
    const isIPadPro = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    
    const result = isIOSDevice || isIPadPro;
    
    
    return result;
  },
 
  /**
   * Helper function to check msSaveOrOpenBlob support
   * @returns {boolean} - True if supported
   */
  supportsMsSaveBlob: () => {
    return typeof window.navigator.msSaveOrOpenBlob !== 'undefined';
  }
};
 
export default PDFResource;